import { messageActions } from "./message-actions"

export default async function authMessageWithHome({ content, title, callback }: { content: string, title: string, callback: () => void }) {
   const defaultAction = {
      name: 'Home',
      callback
   }

   return messageActions({
      children: content,
      title,
      primary: defaultAction,
      clickAwayAction: defaultAction
   })
}